import { Component, OnInit } from '@angular/core';

interface ReportItem {
  label: string;
  pdfPath: string;
  icon?: string;
}

@Component({
  selector: 'app-annual-reports',
  templateUrl: './annual-reports.component.html',
  styleUrls: ['./annual-reports.component.scss']
})
export class AnnualReportsComponent implements OnInit {
  activeTab: 'reports' | 'accounts' = 'reports';

  // ── Annual Reports ────────────────────────────────────────
  annualReports: ReportItem[] = [
    { label: '2024-25', pdfPath: '/assets/pdf/hei/annual-reports/24-25.pdf' },
    { label: '2023-24', pdfPath: '/assets/pdf/hei/annual-reports/23-24.pdf' },
    { label: '2022-23', pdfPath: '/assets/pdf/hei/annual-reports/22-23.pdf' },
    { label: '2021-22', pdfPath: '/assets/pdf/hei/annual-reports/21-22.pdf' },
    { label: 'External Report', pdfPath: '/assets/pdf/hei/annual-reports/external-audit.pdf', icon: 'fa-external-link' },
  ];

  // ── Balance Sheet ─────────────────────────────────────────
  balanceSheets: ReportItem[] = [
    { label: '2024-25', pdfPath: '/assets/pdf/hei/annual-balance-sheet/24-25.pdf' },
    { label: '2023-24', pdfPath: '/assets/pdf/hei/annual-balance-sheet/Balance-sheet-2024.pdf' },
    { label: '2022-23', pdfPath: '/assets/pdf/hei/annual-balance-sheet/BALANCE-SHEET-2023.pdf' },
  ];

  // ── Income & Expenditure ──────────────────────────────────
  incomeExpenditure: ReportItem[] = [
    { label: '2024-25', pdfPath: '/assets/pdf/hei/expenditure/expenditure.pdf' },
    { label: '2023-24', pdfPath: '/assets/pdf/hei/expenditure/Income-expenditure-statement-2024.pdf' },
    { label: '2022-23', pdfPath: '/assets/pdf/hei/expenditure/INCOME-AND-EXPENDITURE-23.pdf' },
  ];

  constructor() { }
  ngOnInit(): void { }

  setActiveTab(tab: 'reports' | 'accounts') {
    this.activeTab = tab;
  }
}

